// extracted by mini-css-extract-plugin
export default {"item":"EnergiOplysningerPeriodiseret_item__qiBvI","markeret":"EnergiOplysningerPeriodiseret_markeret__P9ouQ"};